import TipoCobroCuotaService from '../../services/TipoCobroCuotaService'

export default {
  namespaced: true,
  state: {
    tiposCobroCuota: [],
    tipoCobroCuota: null,
    totalItems: 0,
    currentPage: 1
  },
  getters: {
    tiposCobroCuota: state => state.tiposCobroCuota,
    tipoCobroCuota: state => state.tipoCobroCuota,
    totalItems: state => state.totalItems,
    currentPage: state => state.currentPage
  },
  mutations: {
    setTiposCobroCuota(state, tiposCobroCuota) {
      state.tiposCobroCuota = tiposCobroCuota
    },
    setTipoCobroCuota(state, tipoCobroCuota) {
      state.tipoCobroCuota = tipoCobroCuota
    },
    setTotalItems(state, totalItems) {
      state.totalItems = totalItems
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage
    }
  },
  actions: {
    async fetchTiposCobroCuota({ commit }, { page = 1, limit = 10, filters = {} }) {
      try {
        const response = await TipoCobroCuotaService.getTiposCobroCuota(page, limit, filters)
        commit('setTiposCobroCuota', response.data.data)
        commit('setTotalItems', response.data.total)
        commit('setCurrentPage', page)
        return response
      } catch (error) {
        console.error('Error fetching tipos de cobro de cuota:', error)
        throw error
      }
    },
    async fetchAllTiposCobroCuota({ commit }, filters = {}) {
      try {
        const response = await TipoCobroCuotaService.getAllTiposCobroCuota(filters)
        return response
      } catch (error) {
        console.error('Error fetching all tipos de cobro de cuota:', error)
        throw error
      }
    },
    async fetchTipoCobroCuota({ commit }, id) {
      try {
        const response = await TipoCobroCuotaService.getTipoCobroCuota(id)
        commit('setTipoCobroCuota', response.data.data)
        return response
      } catch (error) {
        console.error('Error fetching tipo de cobro de cuota:', error)
        throw error
      }
    },
    async createTipoCobroCuota({ dispatch }, tipoCobroCuota) {
      try {
        const response = await TipoCobroCuotaService.createTipoCobroCuota(tipoCobroCuota)
        return response
      } catch (error) {
        console.error('Error creating tipo de cobro de cuota:', error)
        throw error
      }
    },
    async updateTipoCobroCuota({ dispatch }, { id, tipoCobroCuota }) {
      try {
        const response = await TipoCobroCuotaService.updateTipoCobroCuota(id, tipoCobroCuota)
        return response
      } catch (error) {
        console.error('Error updating tipo de cobro de cuota:', error)
        throw error
      }
    },
    async deleteTipoCobroCuota({ dispatch }, id) {
      try {
        const response = await TipoCobroCuotaService.deleteTipoCobroCuota(id)
        return response
      } catch (error) {
        console.error('Error deleting tipo de cobro de cuota:', error)
        throw error
      }
    }
  }
}